import store from "../store/mainStore";
import eSesjaInteractiveService from "../services/esesja.interactive.service";
import InteractiveService from "../services/interactive.service";
import { debounce } from "./utils";
import { debounceIntervals } from "../config/debounce.intervals";

async function notifySessionContentChangedImmediate(sessionId) {
    try {
        const isInteractive = !!store.state.appStore?.isInInteractiveMode;
        const hubConnected = !!eSesjaInteractiveService.connectionState?.hub;

        if (isInteractive && hubConnected) {
            await eSesjaInteractiveService.notifySessionContentChanged(sessionId);
            return;
        }

        await InteractiveService.notifySessionContentChanged(sessionId);
    } catch (error) {
        console.log(error);
    }
}

const notifySessionContentChangedDebounced = debounce(
    notifySessionContentChangedImmediate,
    debounceIntervals.sessionContentChanged.interval
);

/**
 * Notify interactive-session admins that agenda/votings content changed.
 * Uses SignalR hub when caller is in interactive mode (excludes self),
 * otherwise HTTP → IHubContext broadcast to the session group.
 * Debounced to avoid toast spam on burst edits.
 */
export function notifySessionContentChanged(sessionId) {
    if (!sessionId) {
        return;
    }

    notifySessionContentChangedDebounced(sessionId);
}
